/**
 * Geo-scoped poll + template reload when country_template changes for THIS session.
 * Site settings / heroCta global → useSiteSettings + admin localStorage (not here).
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGeoScopedConfigRefresh } from "@/hooks/useGeoScopedConfigRefresh";
import {
  buildCountryTemplateWatchScopes,
  filterRevisionForSession,
  GEO_CONFIG_REVISION_EVENT,
  type GeoRevisionEventDetail,
} from "@/lib/geoConfigRevision";
import { isAdminShellPath } from "@/lib/geoConsentRoutes";
import { getServerTemplateConfig } from "@/lib/serverTemplateDetection";

export function GeoConfigSessionRefresh() {
  const { pathname } = useLocation();
  useGeoScopedConfigRefresh();

  useEffect(() => {
    const onRevision = (e: Event) => {
      if (isAdminShellPath(window.location.pathname)) return;
      const raw = (e as CustomEvent<GeoRevisionEventDetail>).detail;
      if (!raw?.bumpedScopes?.length) return;
      const templateKeys = buildCountryTemplateWatchScopes(getServerTemplateConfig());
      const detail = filterRevisionForSession(raw, templateKeys);
      if (!detail?.kinds.includes("country_template")) return;
      window.location.reload();
    };

    if (isAdminShellPath(pathname)) return;
    window.addEventListener(GEO_CONFIG_REVISION_EVENT, onRevision);
    return () => window.removeEventListener(GEO_CONFIG_REVISION_EVENT, onRevision);
  }, [pathname]);

  return null;
}